export const PARTNER_AUDITOR_ROL_NAME = 'partner_auditor';